import { useState, useEffect } from 'react';
import { SnackbarSeverityType } from '../../../enums';
import { Hashtag } from '../../../types/hashtagsType';
import hashtagsApi from '../../../apis/hashtags';

const useHashtags = (
  showToast: (message: string, severity: SnackbarSeverityType) => void
) => {
  const [rows, setRows] = useState<Hashtag[]>([]);
  const [loading, setLoading] = useState(false);

  const getHashtags = async () => {
    try {
      setLoading(true);
      const response = await hashtagsApi.getHashtags();
      const data: Hashtag[] = response ?? [];

      setRows(
        data.map((hashtag: any) => ({
          id: hashtag.id,
          name: hashtag.hashtag
        }))
      );
    } catch {
      showToast('Failed to load hashtags', SnackbarSeverityType.error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHashtags();
    // eslint-disable-next-line
  }, []);

  return { rows, loading, getHashtags };
};

export { useHashtags };
